import * as yup from "yup";

export const schema = yup
  .object({
    username: yup.string().required("이름을 입력해주세요"),
    userId: yup
      .string()
      .required("아이디를 입력해주세요")
      .matches(
        /^[a-z0-9]{4,20}$/,
        "아이디는 4~20자리의 영문 소문자만 입력해주세요"
      ),
    password: yup
      .string()
      .required("비밀번호를 입력해주세요")
      .matches(
        /^(?=.*[a-z])(?=.*[0-9])|(?=.*[a-z])(?=.*[!@#$%^&*?_])|(?=.*[0-9])(?=.*[!@#$%^&*?_]).{8,12}$/,
        "비밀번호는 8~12자리의 영문, 숫자, 특수문자 중 2가지 이상의 조합으로 입력해야 합니다."
      ),
    userPwCheck: yup
      .string()
      .required("비밀번호를 입력해주세요")
      .oneOf([yup.ref("password")], "비밀번호가 일치하지 않습니다."),
    phoneNumber: yup
      .string()
      .required("휴대폰 번호를 입력해주세요")
      .min(13, "휴대폰 번호를 정확히 입력해주세요"),
    email: yup.string().nullable().email("이메일 형식이 아닙니다."),
  })
  .required();
